<template>
    <v-dialog
      v-model="carregando"
      v-if="getCarregando()"
      persistent
      transition="dialog-top-transition"
      max-width="150"
    >
      <div class="text-center py-2 secondary white--text">
        <v-progress-circular
          indeterminate
          class="mb-2"
        ></v-progress-circular>

        <v-spacer></v-spacer>
        
        <span>Carregando...</span>
      </div>
    </v-dialog>

</template>

<script>
import { mapGetters } from 'vuex';

export default {
    name: "LoadingComp",

    data: () => ({
      carregando: true,
    }),

    methods: {
      ...mapGetters(["getCarregando"]),
    },
}
</script>
